import axios from "axios";
import queryString from "query-string";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../shared/vars";

// ===================================================================================
//  GET SITE INFO
// ===================================================================================
export const siteInfoIsLoading = () => {
	return {
		type: "SITE_INFO_IS_LOADING"
	};
};

export const siteInfoHasError = err => {
	return {
		type: "SITE_INFO_HAS_ERROR",
		hasErrored: true,
		error: err
	};
};

export const siteInfoSuccess = data => {
	return {
		type: "SITE_INFO_SUCCESS",
		data
	};
};

export function getSiteInfo() {
	// console.log("getSiteInfo fetching");

	return dispatch => {
		dispatch(siteInfoIsLoading());

		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };
		// console.log('getSiteInfo', AUTH_HEADER)

		return axios
			.get(REACT_APP_API_URL + "load/?language=en&page=categories-content&custom=false", {
				headers: AUTH_HEADER
			})
			.then(response => {
				// console.log("getSiteInfo success");
				dispatch(siteInfoSuccess(response));
			})
			.catch(err => {
				// console.log('getSiteInfo error:', err)
				dispatch(siteInfoHasError(err));
			});
	};
}

// ===================================================================================
//  GET TRANSLATIONS
// ===================================================================================
export function translationsSuccess(translations) {
	return {
		type: "GET_TRANSLATIONS_SUCCESS",
		translations
	};
}

export function getTranslations(permalink, language = "en", custom = 0) {
	return dispatch => {
		const data = {
			language,
			custom,
			page: permalink
		};

		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };
		return axios
			.get(REACT_APP_API_URL + "load/translations?" + queryString.stringify(data), {
				headers: AUTH_HEADER
			})
			.then(response => {
				dispatch(translationsSuccess(response.data));
			})
			.catch(err => {
				console.log("getTranslations error:", err);
			});
	};
}

// ===================================================================================
//  SET PAGE TITLE
// ===================================================================================
export function setpageTitle(title) {
	return {
		type: "SET_PAGE_TITLE",
		title
	};
}

// ===================================================================================
//  GET NOTICES
// ===================================================================================
export function noticesSuccess(notice) {
	return {
		type: "GET_NOTICES_SUCCESS",
		notice
	};
}

export function getNotices() {
	// console.log('getSiteInfo fetching')
	return dispatch => {
		// dispatch(siteInfoIsLoading())

		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };
		// console.log('getSiteInfo', AUTH_HEADER)

		return axios
			.get(REACT_APP_API_URL + "notices", { headers: AUTH_HEADER })
			.then(response => {
				// console.log('getSiteInfo success')
				dispatch(noticesSuccess(response.data.notice));
			})
			.catch(err => {
				console.log("getNotices error:", err);
				// dispatch(siteInfoHasError(err))
			});
	};
}

// ===================================================================================
//  GET PROMOS
// ===================================================================================
export function promosSuccess(promos) {
	return {
		type: "GET_PROMOS_SUCCESS",
		promos
	};
}

export function getPromos() {
	return dispatch => {
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };
		return axios
			.get(REACT_APP_API_URL + "promos", { headers: AUTH_HEADER })
			.then(response => {
				dispatch(promosSuccess(response.data.promos));
			})
			.catch(err => {
				console.log("getPromos error:", err);
				// dispatch(siteInfoHasError(err))
			});
	};
}

// ===================================================================================
//  FREE SHIPPING
// ===================================================================================
export const freeShippingIsLoading = () => {
	return {
		type: "FREE_SHIPPING_IS_LOADING"
	};
};

export const freeShippingSuccess = data => {
	return {
		type: "FREE_SHIPPING_SUCCESS",
		data
	};
};

export const freeShippingHasError = err => {
	return {
		type: "FREE_SHIPPING_HAS_ERROR",
		hasErrored: true,
		error: err
	};
};

export function getFreeShipping() {
	return dispatch => {
		dispatch(freeShippingIsLoading());

		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };
		return axios
			.get(REACT_APP_API_URL + "free-shipping", { headers: AUTH_HEADER })
			.then(response => {
				dispatch(freeShippingSuccess(response.data));
			})
			.catch(err => {
				dispatch(freeShippingHasError(err));
			});
	};
}

// ===================================================================================
//  SET FACEBOOK CAMPAIGN
// ===================================================================================
export function setFacebookCampaign(campaignName) {
	return {
		type: "SET_FACEBOOK_CAMPAIGN",
		campaignName
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/siteInfo.js